import React, { FC } from "react";

import {
  StyledOptionIndicator,
  StyledOptionText,
  StyledAdditionalInfo,
  StyledOptionContentWrapper,
} from "./Styles";
import { Avatar } from "../../Avatar/Avatar";
import { MultiAvatar } from "../../MultiAvatar";

interface OptionContentProps {
  imageUrl?: string | string[];
  color?: string;
  textColor?: string;
  name: string;
  additionalInfo?: string;
}

export const OptionContent: FC<OptionContentProps> = ({
  imageUrl,
  color,
  textColor,
  name,
  additionalInfo,
}) => {
  return (
    <StyledOptionContentWrapper>
      {imageUrl || color ? (
        <StyledOptionIndicator
          className="c-option--label"
          backgroundColor={color}
        >
          {imageUrl ? (
            <>
              {Array.isArray(imageUrl) ? (
                <MultiAvatar
                  className="c-option--multi-avatar"
                  url={imageUrl}
                />
              ) : (
                <Avatar className="c-option--avatar" url={imageUrl} />
              )}
            </>
          ) : null}
        </StyledOptionIndicator>
      ) : null}
      <StyledOptionText className="c-option--text" textColor={textColor}>
        {name}
      </StyledOptionText>
      {additionalInfo ? (
        <StyledAdditionalInfo>{additionalInfo}</StyledAdditionalInfo>
      ) : null}
    </StyledOptionContentWrapper>
  );
};

OptionContent.displayName = "OptionContent";
